import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataPp from './phonics/phonics_data_pp';

function PhonicsPp() {
  return <PhonicsAtoZ letterData={letterDataPp} />;
}

export default PhonicsPp;
